import { LIST_PLACES_QUERY, ListPlacesData } from '../../queries';
import { MutationHookOptions, useMutation } from 'react-apollo';
import { DELETE_PLACE_MUTATION } from './delete-place-mutation';
import { DeletePlacePayload } from './delete-place-payload';
import { DeletePlaceVariables } from './delete-place-variables';
import { MutationUpdaterFn } from 'apollo-client';

const update = (
  variables: DeletePlaceVariables,
): MutationUpdaterFn<DeletePlacePayload> => (cache, { data }) => {
  const query = cache.readQuery<ListPlacesData>({
    query: LIST_PLACES_QUERY,
  });
  if (data && query) {
    const {
      places: { edges },
    } = query;
    const updatedEdges = edges.filter(edge => edge.node.id !== variables.id);
    cache.writeQuery<ListPlacesData>({
      query: LIST_PLACES_QUERY,
      data: { ...query, places: { ...query.places, edges: updatedEdges } },
    });
  }
};

export const useDeletePlaceMutation = (
  variables: DeletePlaceVariables,
  options?: Omit<MutationHookOptions, 'mutation' | 'variables'>,
) =>
  useMutation<DeletePlacePayload, DeletePlaceVariables>(DELETE_PLACE_MUTATION, {
    variables,
    update: update(variables),
    ...options,
  });
